import React from "react";
import { UserCircle2Icon } from "lucide-react";
import {app_url} from "../utils/services";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div className="sm:px-10 py-1 shadow-lg w-full flex items-center justify-between pr-5 sm:pr-16 bg-white">
      <Link to="/">
        <img
          src={`${app_url}/img/d2b_logo.svg`}
          className="h-12 sm:h-12"
          alt="logo"
        />
      </Link>
      {/* <div className="flex bg-slate-200 rounded-full p-1">
        <p
          className={`cursor-pointer text-sm text-center px-4 py-2 rounded-full transition-all ${active("/")}`}
          onClick={() => {
            navigate("/");
          }}
        >
          Chat AI
        </p>
        <p
          className={`cursor-pointer text-sm text-center px-4 py-2 rounded-full transition-all ${active("/resumes")}`}
          onClick={() => {
            navigate("/resumes");
          }}
        >
          Resumes
        </p>
      </div> */}
      <UserCircle2Icon
        size={34}
        className="cursor-pointer bg-primary rounded-full text-white"
      />
    </div>
  );
}

export default Header;
